const dateLocale = require('date-fns/locale/id');

export default {
  dateLocale,
};
